<template>
  <div>
    <data-table :header="table.header">
      <spinner v-if="isPanicAlertSubmitStatusLoading" />
      <div v-else>
        <panic-alert-row
          v-for="(panicAlert, index) in panicAlertList"
          :key="panicAlert.id"
          :alert="panicAlert"
          :index="index"
          :loading="index === loadingIndex"
          @read="readAlert"
          @download="downloadReadyExamsByOrder(panicAlert.numberAlvaroOrder, index)"
        />
      </div>
    </data-table>

    <infinite-loading
      slot="append"
      ref="infiniteLoading"
      :force-use-infinite-wrapper="true"
      @infinite="onInfinite()"
    >
      <span slot="no-more" />
      <span slot="no-results" />
      <span slot="spinner">
        <spinner v-if="panicAlertListStatusLoading === 'STATUS_LOADING'" />
      </span>
    </infinite-loading>

    <div
      v-if="panicAlertListStatusLoading === 'STATUS_END' && panicAlertList.length === 0"
      class="empty-search"
    >
      <svg-loader src="/static/images/icon-no-tubes-found.svg" />
      <p>Não encontramos nenhum resultado para sua busca.</p>
    </div>

    <div
      v-if="panicAlertListStatusLoading === 'STATUS_FAILED' && panicAlertList.length === 0"
      class="empty-search"
    >
      <svg-loader src="/static/images/icon-no-tubes-found.svg" />
      <p>Não foi possível buscar os alertas. Tente novamente.</p>
    </div>

    <PdfViewV2 :content="htmlForDownload" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DataTable from '@/components/common/dataTable/DataTable.vue'
import Spinner from '@/components/common/Spinner.vue'
import InfiniteLoading from 'vue-infinite-loading'
import PanicAlertRow from './PanicAlertRow.vue'
import resultPDFService from '@/api/resultsPDF'
import notify from '@/api/notification'
import PdfViewV2 from '../common/PdfViewV2.vue'

export default {
  name: 'PanicAlertDataTable',
  components: {
    DataTable,
    PanicAlertRow,
    Spinner,
    InfiniteLoading,
    PdfViewV2
  },
  data() {
    return {
      table: {
        header: [
          { title: 'OS', size: 15 },
          { title: 'Paciente', size: 15 },
          { title: 'Exame', size: 15 },
          { title: 'Data da Notificação', size: 15 },
          { title: 'Descrição', size: 35 },
          { title: '', size: 5 }
        ]
      },
      htmlForDownload: new Uint8Array(),
      loadingIndex: null
    }
  },
  computed: {
    ...mapGetters([
      'panicAlertList',
      'panicAlertListStatusLoading',
      'isPanicAlertSubmitStatusLoading'
    ]),
  },
  watch: {
    panicAlertListStatusLoading(newValue) {
      switch (newValue) {
        case 'STATUS_END':
          this.$refs.infiniteLoading?.$emit('$InfiniteLoading:complete')
          break
        case 'STATUS_SUCCESS':
          this.$refs.infiniteLoading?.$emit('$InfiniteLoading:loaded')
          this.setWaitingPanicAlertLoadingStatus()
          break
        case 'STATUS_FAILED':
          this.$refs.infiniteLoading?.$emit('$InfiniteLoading:complete')
          break
        case 'STATUS_INITIAL':
          this.$refs.infiniteLoading?.$emit('$InfiniteLoading:reset')
          break
      }
    }
  },
  methods: {
    ...mapActions(['getPanicAlertList', 'setWaitingPanicAlertLoadingStatus', 'readPanicAlert']),
    onInfinite() {
      this.getPanicAlertList()
    },
    readAlert(id, index) {
      this.readPanicAlert({ id, index })
    },
    async downloadReadyExamsByOrder(numberAlvaroOrder, index) {
      if (!numberAlvaroOrder) return

      this.loadingIndex = index

      try {
        const examCode = this.panicAlertList[index]?.examCode
        const response = await resultPDFService.downloadResultsPDF(numberAlvaroOrder, [examCode])
        this.htmlForDownload = new Uint8Array(response.data)
      } catch (error) {
        notify({
          title: 'AVISO:',
          message: this.$strings.resultsPDFErrorsMessages.downloadFail
        })
      } finally {
        this.loadingIndex = null
      }
    }
  }
}
</script>

<style lang="scss">
.empty-search {
  width: 25%;
  position: relative;
  margin: 6% auto auto;

  .md-icon {
    width: 50px;
    height: 50px;
    margin-bottom: 1em;
    margin-left: 40%;
  }

  p {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #7a7a7a;
  }
}
</style>
